import React, { useEffect } from 'react'
import { Dispatch } from 'redux'
import { Formik } from 'formik'
import { ILanguages } from '../../types/languages'
import { createPack } from '../../actions/pack'
import { getLanguages } from '../../actions/languages'
import { push } from '../../actions/router'
import { initialState } from '../../reducers/pack'
import {
  transformPackInputToState,
  transformPackStateToInput,
} from '../../services/packForm'
import { NavigationGuard } from '../../components'
import { PackForm } from '../PackForm'
import { packValidationSchema } from '../PackForm/validation'

export interface ICreatePackForm {
  groupId: string
  languages: ILanguages
  dispatch: Dispatch
}

export const CreatePackForm = ({
  groupId,
  languages,
  dispatch,
}: ICreatePackForm) => {
  useEffect(() => {
    dispatch(getLanguages())
  }, [dispatch])

  return !languages.isLoading ? (
    <Formik
      initialValues={transformPackStateToInput({
        ...initialState,
        group: groupId,
      })}
      onSubmit={(values) => {
        dispatch(createPack(transformPackInputToState(values)))
      }}
      render={(formikProps) => (
        <>
          <PackForm
            formikProps={formikProps}
            languages={languages}
            submitText="Create Pack"
            cancelAction={() => {
              dispatch(push(`/group/${groupId}/publish`))
            }}
          />
          <NavigationGuard
            message="Are you sure you want to leave this page? Unsaved changes will be lost."
            isBlocking={formikProps.dirty && !formikProps.isSubmitting}
          />
        </>
      )}
      validationSchema={packValidationSchema}
    />
  ) : null
}
